var TorsoView = require('backbone-torso/modules/View');
var estimateDetailsTemplate = require('./estimateDetailsTemplate.hbs');
var applicationUtils = require('./../applicationUtils');
var ExpandableSectionBehavior = require('./../behaviors/ExpandableSectionBehavior');
var InsuranceEstimationDataBehavior = require('./InsuranceEstimationDataBehavior');
var AppointmentTypeDataBehavior = require('./../appointment-type/AppointmentTypeDataBehavior');
var financialFeatureConfigModel = require('./../financial/financialFeatureConfigModel');
var financialFeatureService = require('./../financial/financialFeatureService');
var SecureMessageDataBehavior = require('./../secure-message/SecureMessageDataBehavior');

var withSidebarClassNameModifier = '';
if (applicationUtils.currentApplication === applicationUtils.APPLICATIONS.ADMIN_TOOL) {
  withSidebarClassNameModifier = ' brec-tab__content--side';
}

/**
 * Displays estimate details
 *
 * @class EstimateDetailsWidget
 * @extends Torso.View
 * @constructor
 * @param options {Object}
 *   @param options.accountExternalId {String} the external id of the account to get the estimate for.
 */
module.exports = TorsoView.extend({
  template: estimateDetailsTemplate,
  className: 'brec-tab__content' + withSidebarClassNameModifier,

  behaviors: {
    expandableSectionBehavior: {
      behavior: ExpandableSectionBehavior,
      initiallyExpanded: false
    },
    appointmentSecureMessages: {
      behavior: SecureMessageDataBehavior,
      ids: function(cache) {
        if (!this.view._accountExternalId) {
          return { skipObjectRetrieval: true };
        }

        var criteria = {
          isPatient: true,
          vecnaIds: [this.view._patientVecnaId],
          appointmentCriteria: {
            externalAppointmentCriteria: {
              accountNumbers: [this.view._accountExternalId]
            }
          }
        };
        return cache.fetchIdsByCriteria(criteria);
      }
    },
    insuranceEstimation: {
      behavior: InsuranceEstimationDataBehavior,
      returnSingleResult: true,
      renderOnFetch: true,
      ids: function() {
        var accountExternalId = this.view._accountExternalId;
        var isEstimatedCostEnabled = financialFeatureConfigModel.isEstimatedCostEnabled(financialFeatureConfigModel.CONFIG_LEVEL.NORMAL);
        if (accountExternalId && isEstimatedCostEnabled) {
          return accountExternalId;
        }
      }
    },
    appointmentTypes: {
      behavior: AppointmentTypeDataBehavior,
      renderOnFetch: true,
      ids: { property: 'behaviors.appointmentSecureMessages.data:appointmentDTO.externalAppointment.type'}
    }
  },

  /**
   * @method initialize
   * @override
   * @param options {Object}
   *   @param options.accountExternalId {String} the external id of the account to get the estimate for
   */
  initialize: function(options) {
    options = options || {};
    this._accountExternalId = options.accountExternalId;
    this._patientVecnaId = options.patientVecnaId;

    financialFeatureConfigModel.loadOnce();
  },

  /**
   * @method prepare
   * @override
   */
  prepare: function() {
    var templateContext = TorsoView.prototype.prepare.apply(this);
    var insuranceEstimation = this.getBehavior('insuranceEstimation').data.getModel();

    if (insuranceEstimation) {
      templateContext.negativeInsuranceAdjustment = insuranceEstimation.getNegativeInsuranceAdjustment();
      templateContext.negativeInsurancePayment = insuranceEstimation.getNegativeInsurancePayment();
      templateContext.patientVecnaId = this._patientVecnaId;
      templateContext.accountExternalId = this._accountExternalId;
      var estimateIsPaid = insuranceEstimation.insuranceEstimateIsPaid();
      var adminPaymentAllowed = !estimateIsPaid && financialFeatureService.adminPaymentAllowed();
      var patientPaymentAllowed = !estimateIsPaid && financialFeatureService.patientPaymentAllowed(this.patientVecnaId);
      templateContext.showPaymentButton = adminPaymentAllowed || patientPaymentAllowed;
    }
    templateContext.currentApplication = applicationUtils.currentApplication;
    return templateContext;
  }
});
